module.exports = __webpack_public_path__ + "img/wein-wissen-mobil.ea1e6268.jpg";